import { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import InscripcionClub from "../components/InscripcionClub";
import ContenidoExtra from "../components/ContenidoExtra";
import "./Club.css"
import ImgClub from "./assets/img/imagenes club/ImgClub.jpeg"
import { getConfigPagina, isApiConfigured } from "../services/api";

const DEFAULT_TITULO = "Únete al Club de Balloon&Ben";
const DEFAULT_SUBTITULO = "Sé parte de nuestra comunidad y recibe noticias y sorpresas especiales directamente en tu correo.";
const DEFAULT_FORM_TITULO = "Suscríbete al Club Balloon & Ben";

function Club() {
    const [config, setConfig] = useState({ titulo: null, subtitulo: null, imagen: null, contenido_extra: null, club_form_titulo: null });
    const shouldReduceMotion = useReducedMotion();

    useEffect(() => {
        if (!isApiConfigured()) return;
        getConfigPagina("club")
            .then((cfg) => { if (cfg) setConfig(cfg); })
            .catch(() => {});
    }, []);

    const sectionVariants = {
        hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                duration: shouldReduceMotion ? 0.2 : 0.6,
                ease: [0.22, 1, 0.36, 1],
                staggerChildren: shouldReduceMotion ? 0 : 0.15,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
        },
    };

    return(
        <div className="club">
        <motion.div
            initial="hidden"
            animate="show"
            variants={sectionVariants}
        >
            <motion.div className="club-wrapper" variants={itemVariants}>
                <h1 className="club-title">{config.titulo || DEFAULT_TITULO}</h1>
            </motion.div>
            <motion.img src={config.imagen || ImgClub} alt="" className="img-club" variants={itemVariants} />
            <motion.div className="club-descripciones" variants={itemVariants}>
                <h3 className="club-descripcion">{config.subtitulo || DEFAULT_SUBTITULO}</h3>
            </motion.div>
            <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
        </motion.div>

        <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={itemVariants}
        >
            <InscripcionClub titulo={config.club_form_titulo || DEFAULT_FORM_TITULO} />
        </motion.div>

    </div>
    )

}
export default Club;
